<template>
	<div class="pb-30">
		<md-card class="mt-20">
			<md-card-content class="ask-subject" :style="{padding: '9px'}" >
				<div class="card-inline">
					<p v-text="status" class="ask-status"></p>
					<ul class="list-inline align-right btnleftspaceremove mtm-3">
						<li>
							<md-button class="md-raised md-round md-accent capitalize" v-if="!ask.isClose" v-on:click="doInteraction('close')">Close</md-button>
							<md-button class="md-raised md-round md-accent capitalize" v-if="!ask.isClose" v-on:click="doInteraction('comment')" @click="expand('comment')">Comment</md-button>
						</li>
					</ul>
				</div>
			</md-card-content>
		</md-card>
		<md-card class="mt-30">
			<md-card-header class="ask-subject" :style="communityStyle">
				<ul class="list-inline mb-0">
					<li>{{$lodash.has(community, 'name') ? community.name + ': ' + (ask.request && ask.request.subject  ? ask.request.subject : 'N/A') : 'N/A' }}</li>
					<li class="count" v-if="ask.request && ask.request.comment && ask.request.comment.length">{{ask.request.comment.length}}</li>
				</ul>
			</md-card-header>
		</md-card>
		<template>
			<md-card>
				<md-card-content class="ask-detail-section ask-text-content">
					<div class="ask-detail">
						<div class="inline-grid">
							<div class="ask-member-details">
								<div class="edit-ask" v-if="ask.request && ask.request.first && ask.request.last">
									<span class="display-link" v-if="ask.memberId" @click="goToProfile(ask.memberId)">{{ ask.request.first + ' ' +  ask.request.last }}</span>
									<span v-else-if="ask.request.first && ask.request.last">{{ ask.request.first + ' ' +  ask.request.last }}</span>
									<span v-else>{{ ask.email }}</span>
								</div>
								<span v-if="ask.email">{{ask.email}}</span>
							</div>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Channel</p>
							<span>{{ask.request && ask.request.channelType ? ask.request.channelType : 'N/A'}}</span>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Request Received</p>
							<span v-if="ask.createdAt">{{ask.createdAt | momentDate}}</span>
							<span v-else>N/A</span>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Advisors Asked</p>
							<span>N/A</span>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Advisor Feedback</p>
							<span>N/A</span>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Member Role</p>
							<span v-if="ask.request && ask.request.dynamicFields && ask.request.dynamicFields.memberRole" class="ask-member-role"><b>{{ask.request.dynamicFields.memberRole}}</b></span>
							<span v-else>N/A</span>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Advice Area</p>
							<span v-if="ask.request && ask.request.dynamicFields && ask.request.dynamicFields.adviceArea" class="ask-member-role"><b>{{ask.request.dynamicFields.adviceArea}}</b></span>
							<span v-else>N/A</span>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Request Sent</p>
							<span>N/A</span>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Responses</p>
							<span>N/A</span>
						</div>
						<div class="inline-grid">
							<p class="ask-header">Member Feedback</p>
							<span>N/A</span>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</template>
		<md-card class="mt-30">
	        <md-card-header md-alignment="space-between" class="md-title m-left-5">Request</md-card-header>
  			<md-card-content class="card-content">
				<form>
					<md-field class="create-ask m-left-5">
						<label class="card-header">Subject</label>
						<p name="subject" v-if="ask.request && ask.request.subject" placeholder="Request summary..." >{{ask.request.subject}}</p>
						<p v-else> N/A </p>
					</md-field>
					<div class="create-ask ask-description-area form-group m-left-5">
						<label class="card-header">Description</label>
						<p  class=" description  font-16" id="textarea" v-if="askRequestDetail" placeholder="Describe the request..."> {{askRequestDetail}} </p>
						<p v-else> N/A </p>
					</div>
				</form>
			</md-card-content>
	    </md-card>
	    <md-card class="mt-30">
		      <md-card-expand>
		        <md-card-actions md-alignment="space-between">
		        	<md-card-expand-trigger>
		        		<md-button class="expand-button-size"><strong @click="expand('tag')" class="upper-word">Tags <span v-text="`(${$lodash.has(ask.tags, 0) ? ask.tags.length : '0'})`"></span></strong></md-button>
      				</md-card-expand-trigger>
      			</md-card-actions>
	      </md-card-expand>
	    </md-card>
	    <md-card class="mt-30 adviser-section">
		      <md-card-expand>
				<md-card-actions md-alignment="space-between">
		        	<md-card-expand-trigger>
		        		<md-button class="expand-button-size"><strong @click="expand('adviser')" class="upper-word">Advisers <span v-text="`(0)`"></span></strong>
						</md-button>
      				</md-card-expand-trigger>
      			</md-card-actions>
	      </md-card-expand>
	    </md-card>
	    <md-card class="mt-30" id="response-section">
		      <md-card-expand>
		        <md-card-actions md-alignment="space-between">
		        	<md-card-expand-trigger>
		        		<md-button class="expand-button-size"><strong @click="expand('response')" class="upper-word">Responses <span v-text="`(0)`"></span></strong></md-button>
      				</md-card-expand-trigger>
      			</md-card-actions>
	      </md-card-expand>
	    </md-card>
		<md-card class="mt-30" id="response-section">
		      <md-card-expand>
		        <md-card-actions md-alignment="space-between">
		        	<md-card-expand-trigger>
		        		<md-button class="expand-button-size"><strong @click="expand('feedback')" class="upper-word">Feedback <span v-text="`(0)`"></span></strong></md-button>
      				</md-card-expand-trigger>
      			</md-card-actions>
	      </md-card-expand>
	    </md-card>
		<template>
			<div v-if="ask.request" class="mt-30">
				<md-card id="commentDivSection">
				<md-card-expand >
					<md-card-actions md-alignment="space-between"  ref="commentDivSection" >
						<md-card-expand-trigger>
							<md-button class="expand-button-size"><strong><span @click="expand('comment')" class="upper-word">Comments <span>({{ask.request && ask.request.comments ? ask.request.comments.length : 0}})</span></span></strong></md-button>
						</md-card-expand-trigger>
					</md-card-actions>
					<md-card-expand-content>
						<md-card-content class="comments">
							<div class="comments">
								<div
								v-if="ask.request.comments && ask.request.comments.length"
								v-for="(comment,index) in sortComments"
								class="activity"
								:key="'comment-'+index">
									<b>{{ comment.when | momentDate }} - {{ comment.memberName }}</b>
									<p class="ask-description">{{ comment.comment }}</p>
								</div>
							</div>
							<div>
								<form @submit.prevent="addComment">
									<md-field class="create-ask textareaAfter">
										<md-textarea class="md-textarea padding-left-10" placeholder="Enter your comment"></md-textarea>
									</md-field>
									<md-field class="create-ask">
										<md-button class="md-accent md-raised upper-word md-white-color" type="submit">Add Comment</md-button>
									</md-field>
								</form>
							</div>
						</md-card-content>
					</md-card-expand-content>
				</md-card-expand>
				</md-card>
			</div>
		</template>
		<!-- <activity-log class="mt-30" :ask="ask">Activity log goes here...</activity-log> -->
	</div>
</template>

<script>
import API from "../services/API"
import AskFeedback from "@/components/AskFeedback";
import Vue from 'vue';
import Paginate from 'vuejs-paginate'
import { sanitizeInput } from '@/utils/sanitizer';
Vue.component('paginate', Paginate)

export default {
	name: 'RequestDetail',
	components: {
		AskFeedback
	},
	computed: {
		sortComments: function() {
		if (this.ask.request && this.ask.request.comments) {
			let comments = this.ask.request.comments.slice()
			return comments.sort((a, b) => {
			return a.when < b.when ? 1 : -1;
			});
		}
		}
	},
	data() {
    	return {
    		api: new API(),
    		ask: {},
    		community: {},
		 	communityStyle: {
		    	backgroundColor: "white",
		    	color: "black"
		  	},
      		fullPage: true,
			status: '',
			askRequestDetail: '',
			opened: []
		}
	},
	watch: {
		'$route': function() {
			this.onCreated();
		}
	},
    async created() {
		this.onCreated();
	},
    methods: {
		async onCreated() {
			this.authUser = localStorage.getItem('authUser') ? JSON.parse(localStorage.getItem('authUser')) : {};
			await this.loadData();
			this.status = 'Incomplete ' + (this.ask.isClose ? '(Closed)' : '');
			var action = this.$route.query.action;
			if (this.$route.query.action) {
				this.doInteraction(action);
			}
		},
		async loadData() {
			await this.api.get(`asks/incomplete-request-details/${this.$route.params.ask_id}`).then(async ask => {
			  	if (ask.data instanceof Object || ask.data instanceof Array) {
					this.ask = ask.data;
					this.status = 'Incomplete ' + (this.ask.isClose ? '(Closed)' : '');
					this.askRequestDetail = this.ask.request.text;
					if (this.ask.request.bio) {
						this.askRequestDetail = `${this.ask.request.bio}\n\n` + this.askRequestDetail;
					}
					if (this.ask.request.closeNicely) {
						this.askRequestDetail += `\n\n${this.ask.request.closeNicely}`;
					}
					if (this.ask && this.ask.communityId) {
						this.community = this.ask.communityId;
						if (this.$lodash.has(this.community, 'customSettings')) {
							this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
							this.communityStyle.color = this.community.customSettings.secondaryColor;
						}
					}
			  	}
		  	});
		},
    	expand(id) {
			var index = this.opened.indexOf(id);
    		if (index !== -1) {
				this.opened.splice(index, id);
			} else {
    			this.opened.push(id);
    		}
    	},
    	async doInteraction(action) {
			if (action === 'close') {
					await this.api
					.post(`asks/${this.ask._id}/incomplete-request/close`)
					.then(response => {
						this.$toast.success('This Request closed successfully', {duration: 5000});
						this.ask = response.data;
						this.status = 'Incomplete ' + (this.ask.isClose ? '(Closed)' : '');
					});
			} else if (action == 'comment') {
				setTimeout(function () {
					const elmnt = document.getElementById('commentDivSection');
					elmnt.scrollIntoView({
						behavior: 'smooth'
					});
				}, 0);
			}
		},
		goToProfile: function(Id) {
			let route = this.$router.resolve({path: `/members/${Id}`});
			window.open(route.href, '_blank');
		},
		async addComment($event) {
			// if (!this.ask.isClose) {
				if ($event.target[0].value) {
					var commentVal = sanitizeInput($event.target[0].value);
					await this.api.post(`asks/${this.ask._id}/incomplete-request/comment`, {comment: commentVal}).then(async response => {
						this.$emit("reload");
						this.reserveStatus = false;
						this.reserveTxt = 'Reserve';
						await this.loadData();
						$event.target.reset();
					});
	    		}
			// } else {
			// 	// console.log("this.community :", this.ask.community);
			// 	let closeMessage = this.ask.community.content.closeRequestMessage;
			// 	this.$toast.error(closeMessage);
			// }
		},
		scrollToEle(scrollPos) {
			const vs = this.$root.$children[0].$children[0].$refs['vs'];
			const y = scrollPos;
			vs.scrollTo({
				y
			});
		},
		sanitizeInput(event) {
            return sanitizeInput(event);
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/components/IncompleteRequestDetail.vue